module.exports = "/static-assets/_next/static/images/receive-5ada31eeabe48dd1939bc8a482e1d835.png";